export class PlanVM {
     PlanId:number;

    PlanName:string;

    PlanCost:number;

    PlanSerachPermissionIds:string;

    IsPlanActive:boolean;
}    